import React from 'react';
import clsx from 'clsx';

import PropTypes from 'prop-types';

import {
  Avatar,
  Card,
  CardContent,
  Grid,
  Typography,
  colors,
  makeStyles
} from '@material-ui/core';

import TotalIcon from '@material-ui/icons/NotificationsTwoTone';

var numeral = require('numeral');

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%'
  },
  avatar: {
    backgroundColor: colors.blue[400],
    height: 56,
    width: 56
  }
}));

const Total = ({ className, ...rest }) => {
  const classes = useStyles();

  return (
    <Card className={clsx(classes.root, className)} {...rest}>
      <CardContent>
        <Grid
          container
          justify="space-between"
          spacing={3}
        >
          <Grid item>
            <Typography
              color="textSecondary"
              gutterBottom
              variant="h6"
            >
              TOTAL
            </Typography>
            <Typography
              color="textPrimary"
              variant="h3"
            >
              ({numeral(rest.total).format('0')})
            </Typography>
          </Grid>
          <Grid item>
            <Avatar className={classes.avatar}>
              <TotalIcon />
            </Avatar>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

Total.propTypes = {
  className: PropTypes.string
};

export default Total;
